//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'setChartStyle-editor',
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  data: function data() {
    return {
      options: [{
        value: '￥',
        label: '￥'
      }, {
        value: '$',
        label: '$'
      }, {
        value: '€',
        label: '€'
      }, {
        value: '￡',
        label: '￡'
      }],
      selectedOption: this.optionModel // 假设你想绑定 optionModel 到 select 组件
    };
  },
  watch: {
    optionModel: {
      handler: function handler(newVal) {
        this.selectedOption = newVal;
      },
      immediate: true
    },
    selectedOption: function selectedOption(newVal) {
      this.$emit('update:optionModel', newVal); // 使 v-model 工作
    }
  }
};